/**
 * engineNormalJson_Merge_JsonKey.ts - JsonKey processing for EngineNormalJson
 * Pure ES Module version
 */

import { convertToString } from './engineNormalJson_Merge_Slot.js';
import { GenerateHtmlJson } from '../../base/loader/generateHtmlJson.js';
import type { EngineNormalJson } from './engineNormalJson.js';
import type { JsonObject, JsonValue } from '../../../../Assembler/dist/app/json/jsonValue.js';
import type { TemplateOperation } from '../../../../Assembler/dist/model/templateOperation.js';

import { TemplateOperationKind } from '../../../../Assembler/dist/model/templateOperationKind.js';
/**
 * Process a JSON key entry (TYPE_JSONKEY)
 * NOTE: JsonKey entries should have been replaced by engine._loader.mergeHtmlWithJson already
 * This code is a fallback for cases where JSON was not merged
 */
export function ProcessJsonKey(
    engine: EngineNormalJson,
    result: { append(value: string): void },
    key: string,
    value: JsonValue | unknown,
    isSkipMarked: boolean,
    templateKey: string,
    currentTemplateName: string,
    operations: TemplateOperation[],
    _jsonData: JsonObject
): void {
    const keyName = GenerateHtmlJson.getKeyName(key);

    if (isSkipMarked) {
        result.append(engine._loader!.defaultSkipJson);
        operations.push({
            templateName: templateKey,
            kind: TemplateOperationKind.KeySkip,
            target: `{{!$${keyName}}}`,
            replacedWith: `${currentTemplateName}_${keyName}`,
            paramJson: '',
            operations: []
        });
        return;
    }

    result.append(convertToString(value));
}
